import axios from "axios";

export default function checkMaintenanceAlert() {
  return new Promise((resolve, reject) => {
    axios
      .get("account/public/api/v1/check-maintenance-alert")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
